// extracted by mini-css-extract-plugin
export var body = "_h2-0";
export var sectionHeader = "_h2-4";
export var shortcutColumns = "_h2-2";
export var shortcutList = "_h2-1";
export var shortcutSection = "_h2-3";